import { BaseEntity } from "app/shared/model/app.model";
import { NameDescSortId } from "app/shared/model/properties.model";
import { Alert, AlertEvent, AlertInstance } from "ng/src/app/alerts/shared/alert.model";
import { BaseProjections, HasLogRequest, HasUserDetails, NotificationProjections } from "app/shared/model/request-parameter.model";
import { Note } from "ng/src/app/notes/shared/note.model";
import { FileAttachment } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";
import { KeyedValueItem } from "ng/src/app/shared/model/logbook.model";

export module Notification {
    export interface Query extends HasLogRequest, HasUserDetails {
        updatedAfter?: string;
        toastSeen?: boolean;
        projection?: string | BaseProjections | NotificationProjections;
    }

    export module Projections {
        export interface WithLogName extends Notification {
            logName: string;
        }
    }
}

export interface Notification extends BaseEntity {
    type: NameDescSortId;
    subject: string;
    message: string;
    note: Note;
    fileAttachment: FileAttachment;
    toastSeen: boolean;
    seen: boolean;

    alert: Alert;
    alertEvent: AlertEvent;
    alertInstance: AlertInstance;

    logId?: number;
    logName?: string;
    displayDate?: string;
    detailLink?: string;
    notificationLink?: string;
}

export interface SyncedNotificationsData {
    notifications: Notification.Projections.WithLogName[];
    pagingAtEnd: boolean;
    unreadCount: number;
    userId?: number;
}

export interface SystemNotification {
    id: number
    relevance: SystemNotificationRelevance
    attention: SystemNotificationAttention
    title: string
    content: string
    updated: string
    created: string
    endTime?: string
}

export interface SystemNotificationAttention extends Omit<KeyedValueItem, 'sortOrder'> {
    id: SystemNotificationAttentionId
}

export interface SystemNotificationRelevance extends Omit<KeyedValueItem, 'sortOrder'> {
    id: SystemNotificationRelevanceId
}

export enum SystemNotificationAttentionId {
    SILENT = 1,
    BANNER = 2,
    STICKY = 3,
    ALERT = 4
}

export enum SystemNotificationRelevanceId {
    ALL_USERS = 1,
    ADMIN_ONLY = 2
}